import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth } from "../../lib/api";
import { toast } from "sonner";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1cfd506a-8d58-4dee-aebc-bac5c6ae0bd8/artifacts/olw9pyi7_1630458636004.jpg";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@elephantequity.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-12">
          <img src={LOGO_URL} alt="Elephant Equity" className="h-9 w-9 object-contain" />
          <span className="font-display text-xl tracking-tight">
            Elephant <span className="text-[#A6192E]">Equity</span>
          </span>
        </Link>
        <div className="bg-white border border-[#EBEAE0] rounded-sm p-10">
          <div className="text-xs tracking-[0.22em] uppercase text-[#A6192E]">Admin</div>
          <h1 className="font-display text-3xl tracking-tight mt-3">Sign in</h1>
          <p className="text-sm text-[#4A4D4A] mt-2">Manage portfolio and news.</p>
          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div>
              <label className="text-xs uppercase tracking-[0.18em] text-[#4A4D4A]">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="mt-2 w-full px-4 py-3 bg-[#FAF9F6] border border-[#EBEAE0] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#A6192E]/30 focus:border-[#A6192E]"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.18em] text-[#4A4D4A]">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="mt-2 w-full px-4 py-3 bg-[#FAF9F6] border border-[#EBEAE0] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#A6192E]/30 focus:border-[#A6192E]"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full px-6 py-3.5 bg-[#A6192E] hover:bg-[#8C1527] text-white text-sm font-medium tracking-wide rounded-sm transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center text-xs text-[#7A7D7A] mt-6 link-underline">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
